/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSlice } from '@reduxjs/toolkit';

import { entityAdapter } from './adapter';
import { createBoostReducer } from './ducks/create';
import { removeBoostReducer } from './ducks/delete';

const slice = createSlice({
  name: 'boosts',
  initialState: entityAdapter.getInitialState(),
  extraReducers: {
    ...createBoostReducer,
    ...removeBoostReducer
  },
  reducers: undefined
});

export const reducer = slice.reducer;
